import React from "react";
import { Container, Row, Col } from "react-bootstrap";

function Banner(props) {
  return (
    <div className="services_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Serverless">
                <h1>Our Top-Notch Serverless Computing Services</h1>
              </div>
              <p className="main_para">
                Our serverless computing services are designed to help your
                business derive the benefits of going serverless and prototype
                new features to the overall business model while reducing the
                business's dependency on servers/infrastructure.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banner_content_txt">
              <p>
                Spending years in the world of technology, we've become a
                purpose-driven business determined to find different ways of
                utilizing modern technologies to improve organizational conduct.
                And serverless computing just happens to be one of them!
              </p>
              <ul>
                <li>Serverless Infrastructure</li>
                <li>Platform Support</li>
                <li>Network Management</li>
                <li>Virtualization Assistance</li>
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
